import React, { useContext, useEffect, useState } from "react";
import ApplicationContext from "../../../context/index";
import BankDetailsForm from "./indexForm";
import CircularProgress from "@mui/material/CircularProgress";
import useApi from "../../../hooks/useApi";
import { Box } from "@mui/material";
import { reBuildMandateList } from "../../../helpers/utils";
import { ReducerUtils } from "../../../constants/reducers";
import { useHistory } from "react-router";
import { useStyles } from "../indexFormStyles";
import { withStyles } from "@mui/styles";
import { getRoute, getStorageItem } from "../../../helpers/utils";
import { postWebService } from "../../../helpers/server";

function BankDetails({ classes: { loaderBox } }) {
  const mandates = useApi(`bank-mandates.php`);
  const { state, dispatch } = useContext(ApplicationContext);
  const history = useHistory();

  const [form, setForm] = useState({
    declaration: false,
    is_mandate: 0,
    search: "",
  });
  const [isFormSubmitted, setIsFormSubmitted] = useState(false);
  const [inputValue, setInputValue] = useState("");
  const [searchCount, setSearchCount] = useState(-1);
  const [isLoaded, setIsLoaded] = useState(true);
  const [selectedBankOption, setSelectedBankOption] = useState({
    code: "",
    label: "Select",
    is_mandate: "",
  });
  const [declaration, setDeclaration] = useState({
    agree: false,
  });

  useEffect(() => {
    dispatchEvent(
      ReducerUtils.mandate.list,
      mandates?.length > 0 ? reBuildMandateList(mandates) : []
    );
    setTimeout(() => setIsLoaded(true), 100);
  }, [mandates]);

  useEffect(() => {
    setDeclaration({
      ...declaration,
      agree: false,
    });
  }, [selectedBankOption]);

  const dispatchEvent = (type, payload) => dispatch({ type, payload });

  const handleChange = (event) => {
    setDeclaration({
      ...declaration,
      [event.target.name]: event.target.checked,
    });
  };

  const navigateTo = (pathname) => history.push({ pathname });

  const onTextSearch = (value, count) => {
    setInputValue(value);
    setSearchCount(count);
  };

  const cbError = (error) => {
    setIsFormSubmitted(false);
  };

  const updateOrderDetails = async () => {
    try {
      const response = await postWebService("updateorderstatusService.php", {
        cid: Number(getStorageItem("cid")),
        oid: Number(getStorageItem("oid")),
        is_mandate: selectedBankOption?.is_mandate
          ? Number(selectedBankOption?.is_mandate)
          : 0,
        mandate_bank_name: selectedBankOption?.code ?? null,
      });

      if (response.data.code === 200) {
        setIsFormSubmitted(false);
        navigateTo(getRoute("payment"));
      }
    } catch (error) {
      cbError(error);
    }
  };

  const handleProceed = () => updateOrderDetails();

  return isLoaded && state?.mandates?.length > 0 ? (
    <BankDetailsForm
      banks={mandates}
      declaration={declaration}
      form={form}
      handleChange={handleChange}
      handleProceed={handleProceed}
      inputValue={inputValue}
      onTextSearch={onTextSearch}
      searchCount={searchCount}
      selectedBankOption={selectedBankOption}
      setSelectedBankOption={setSelectedBankOption}
    />
  ) : (
    <Box className={loaderBox}>
      <CircularProgress color={"secondary"} />
    </Box>
  );
}

export default withStyles(useStyles, { withTheme: true })(BankDetails);
